import { activeDayWorkout } from '../stores';

export const disableActiveDay = () => {
  activeDayWorkout.clear();
};
